module.exports = __webpack_public_path__ + "img/Bring people together.36864126.gif";